import React, { useState } from 'react'
import Icon from 'components/Icon'
import Select, { components } from 'react-select'

const Control = (props) => (
  <components.Control {...props} className="border border-gray-300 px-3 py-1" />
)

const Option = (props) => {
  const { innerProps, data: { label, value, image }, isSelected, isFocused } = props

  return (
    <div {...innerProps} className={`p-2 bg-white hover:bg-gray-100 cursor-pointer flex justify-between items-center ${isSelected ? 'bg-blue-200' : isFocused ? 'bg-blue-100' : ''}`}>
      <div>{ label }</div>
      { image &&
        <img className="w-8 h-8 rounded-full" src={image} />
      }
    </div>
  )
}

const Contact = ({ attribute, state, onChange }) => {
  const { options, name, disabled } = attribute

  return (
    <fieldset className="space-y-1">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <Select
        value={options.find(({ value }) => value == state)}
        onChange={({ value }) => onChange(value)}
        options={options}
        openMenuOnFocus
        isDisabled={disabled}
        components={{
          Control,
          Option,
        }}
        styles={{
          placeholder: (base) => ({ ...base, color: '#9eaebf', fontSize: '1rem' }),
          singleValue: (base) => ({ ...base, color: '#1a202c', fontSize: '1rem' }),
          valueContainer: (base) => ({ ...base, color: '#1a202c', fontSize: '1rem', padding: 0 }),
        }}
        theme={(theme) => ({ ...theme, borderRadius: 0 })}
      />
    </fieldset>
  )
}

export default Contact
